<template>
  <div class="sdg_box_indicators">
    <div class="person-wrap" ref="personWrap">
      <ul class="person-list" ref="li1">
        <!--  :class="{'current':currentIndex===index}" -->
        <!-- sdgImgage sdgList -->
        <li
          class="person-item"
          v-for="(item,index) in sdgList"
          :key="index"
          @click="select(index,$event)"
        >
          <div class="li_bg" :class="{'li_bg_current':currentIndex===index}"></div>
          <!-- <img :src="item" alt /> -->
          <img :src="`${GLOBAL.imageUrl}${item.icon}`" alt />
        </li>
      </ul>
    </div>
    <div class="wrapper" ref="wrapper">
      <div class="content" ref="li2">
        <div
          class="sdg_bg_box"
          v-for="(item,index) in sdgList"
          :key="index"
          :style="{background:bg_color[index]}"
        >
          <!--首页 -->
          <div class="sdg_bg_box_div cla_1" v-if="index == 0">
            <div class="first_page">
              <div class="first_page_box">
                <div class="first_page_box_content" >
                  <div class="first_page_box_content_target" v-for="(item,index) in text"  @click="select(index + 1,$event)"> 
                    <img class="top_img" :src="images[index]" />
                    <div class="text_" :style="{background:bg_color[index+1]}">
                      <div class="title">
                        <img :src="text[index].icon" />
                        <p  :class="[language == 'zh'?'zhFamily':'enfamily']" style="lineHeight:16px">{{text[index].tit}}</p>
                      </div>

                      <div class="content" :class="[language == 'zh'?'zhFamily':'enfamily']" style="lineHeight:22px">{{text[index].content}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 其他页面 v-show="item.id != 1"-->
          <div class="sdg_bg_box_div" v-if="index!=0">
            <div class="back_" :style="{color:bg_color[index]}" @click="select(0,$event)">
              {{$t('knowledgeBase.sdgs')}}
            </div>
            <p class="sdg_bg_box_title" :class="[language == 'zh'?'zhFamily':'enfamily']">{{item.title}}</p>
            <div class="sdg_bg_box_content">
              <div class="sdg_bg_box_img">
                <img :src="`${GLOBAL.imageUrl}${item.image}`"  />
              </div>
              <div class="sdg_bg_box_text">
                <div class="sdg_bg_box_text_content" :class="[language == 'zh'?'zhFamily':'enfamily']" v-html="item.description"></div>
                <div class="sdg_btn">
                  <div class="sdg_btn_box" @click="openMenu(0,bg_color,index,item.goalId)">
                    <p class="sdg_btn_box_p" :class="[language == 'zh'?'zhFamily':'enfamily']">  {{$t('knowledgeBase.indicatorSystem')}}</p>
                    <div class="sdg_btn_box_i">
                      <div class="hr_"></div>

                      <div class="sdg_btn_box_i_posi">
                        <i class="iconfont icon-jiantou"></i>
                      </div>
                    </div>
                  </div>

                  <div class="sdg_btn_box" @click="openMenu(1,bg_color,index,item.goalId)">
                    <p class="sdg_btn_box_p" :class="[language == 'zh'?'zhFamily':'enfamily']">  {{$t('knowledgeBase.story')}}</p>
                    <div class="sdg_btn_box_i">
                      <div class="hr_"></div>

                      <div class="sdg_btn_box_i_posi">
                        <i class="iconfont icon-jiantou"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RightContent></RightContent>
  </div>
</template>
<script>
import util from '@/util/util.js'
import { goalList } from "@/axios/api.js";
import BScroll from "better-scroll";
import bus from "@/bus";
export default {
  name: "sdgsindicators",
  components: {
    RightContent: () => import("@/components/SdgsIndicators/RightContent.vue")
  },
  data() {
    return {
      current: 0,
      sdgList: null,
      // translateX: 100,
      bg_color: [
        "rgba(200, 200, 200, 1)",
        "rgba(253, 28, 44, 1)",
        "rgba(209, 159, 40, 1)",
        "rgba(38, 155, 71, 1)",
        "rgba(194, 31, 50, 1)",
        "rgba(239, 62, 42, 1)",
        "rgba(0, 137, 217, 1)",
        "rgba(252, 182, 21, 1)",
        "rgba(142, 23, 55, 1)",
        "rgba(243, 108, 36, 1)",
        "rgba(225, 21, 132, 1)",
        "rgba(249, 156, 36, 1)",
        "rgba(207, 141, 41, 1)",
        "rgba(70, 118, 59, 1)",
        "rgba(0, 124, 187, 1)",
        "rgba(62, 175, 73, 1)",
        "rgba(1, 85, 138, 1)",
        "rgba(24, 53, 103, 1)"
      ],
   
      images: [
        `${util.ImageUrl}/sdg/goal/goal_01.png`,
        `${util.ImageUrl}/sdg/goal/goal_02.png`,
        `${util.ImageUrl}/sdg/goal/goal_03.png`,
        `${util.ImageUrl}/sdg/goal/goal_04.png`,
        `${util.ImageUrl}/sdg/goal/goal_05.png`,
        `${util.ImageUrl}/sdg/goal/goal_06.png`,
        `${util.ImageUrl}/sdg/goal/goal_07.png`,
        `${util.ImageUrl}/sdg/goal/goal_08.png`,
        `${util.ImageUrl}/sdg/goal/goal_09.png`,
        `${util.ImageUrl}/sdg/goal/goal_10.png`,
        `${util.ImageUrl}/sdg/goal/goal_11.png`,
        `${util.ImageUrl}/sdg/goal/goal_12.png`,
        `${util.ImageUrl}/sdg/goal/goal_13.png`,
        `${util.ImageUrl}/sdg/goal/goal_14.png`,
        `${util.ImageUrl}/sdg/goal/goal_15.png`,
        `${util.ImageUrl}/sdg/goal/goal_16.png`,
        `${util.ImageUrl}/sdg/goal/goal_17.png`,
      ],

    //   sdgImgage: [
    //     require("./assets/image/Sdg/index_0.png"),
    //     require("./assets/image/Sdg/index_1.png"),
    //     require("./assets/image/Sdg/index_2.png"),
    //     require("./assets/image/Sdg/index_3.png"),
    //     require("./assets/image/Sdg/index_4.png"),
    //     require("./assets/image/Sdg/index_5.png"),
    //     require("./assets/image/Sdg/index_6.png"),
    //     require("./assets/image/Sdg/index_7.png"),
    //     require("./assets/image/Sdg/index_8.png"),
    //     require("./assets/image/Sdg/index_9.png"),
    //     require("./assets/image/Sdg/index_10.png"),
    //     require("./assets/image/Sdg/index_11.png"),
    //     require("./assets/image/Sdg/index_12.png"),
    //     require("./assets/image/Sdg/index_13.png"),
    //     require("./assets/image/Sdg/index_14.png"),
    //     require("./assets/image/Sdg/index_15.png"),
    //     require("./assets/image/Sdg/index_16.png"),
    //     require("./assets/image/Sdg/index_17.png")
    //   ],
      currentIndex: 0, //当前显示的下标
      listHeight: [],
      scrollY: 0,
      menuIndexChange: true
    };
  },
  created() {},
  mounted() {
        bus.$emit('showLoadingFun',true)
    this.getGoalList();



  },
  computed:{
    text(){
      return [
        {
          tit: this.$t('sdgDataBase.sdg.GOAL1'),
          content: this.$t('sdgDataBase.sdg.GOAL1Value'),
          icon: require("@/assets/image/SdgIcon/sdg_03.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL2'),
          content: this.$t('sdgDataBase.sdg.GOAL2Value'),
          icon: require("@/assets/image/SdgIcon/sdg_06.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL3'),
          content: this.$t('sdgDataBase.sdg.GOAL3Value'),
          icon: require("@/assets/image/SdgIcon/sdg_08.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL4'),
          content: this.$t('sdgDataBase.sdg.GOAL4Value'),
          icon: require("@/assets/image/SdgIcon/sdg_10.png")
        },
        {
         tit: this.$t('sdgDataBase.sdg.GOAL5'),
          content: this.$t('sdgDataBase.sdg.GOAL5Value'),
          icon: require("@/assets/image/SdgIcon/sdg_12.png")
        },
        {
         tit: this.$t('sdgDataBase.sdg.GOAL6'),
          content: this.$t('sdgDataBase.sdg.GOAL6Value'),
          icon: require("@/assets/image/SdgIcon/sdg_14.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL7'),
          content: this.$t('sdgDataBase.sdg.GOAL7Value'),
          icon: require("@/assets/image/SdgIcon/sdg_16.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL8'),
          content: this.$t('sdgDataBase.sdg.GOAL8Value'),
          icon: require("@/assets/image/SdgIcon/sdg_18.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL9'),
          content: this.$t('sdgDataBase.sdg.GOAL9Value'),
          icon: require("@/assets/image/SdgIcon/sdg_20.png")
        },
        {
         tit: this.$t('sdgDataBase.sdg.GOAL10'),
          content: this.$t('sdgDataBase.sdg.GOAL10Value'),
          icon: require("@/assets/image/SdgIcon/sdg_22.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL11'),
          content: this.$t('sdgDataBase.sdg.GOAL11Value'),
          icon: require("@/assets/image/SdgIcon/sdg_24.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL12'),
          content: this.$t('sdgDataBase.sdg.GOAL12Value'),
          icon: require("@/assets/image/SdgIcon/sdg_26.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL13'),
          content: this.$t('sdgDataBase.sdg.GOAL13Value'),
          icon: require("@/assets/image/SdgIcon/sdg_28.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL14'),
          content: this.$t('sdgDataBase.sdg.GOAL14Value'),
          icon: require("@/assets/image/SdgIcon/sdg_30.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL15'),
          content: this.$t('sdgDataBase.sdg.GOAL15Value'),
          icon: require("@/assets/image/SdgIcon/sdg_32.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL16'),
          content: this.$t('sdgDataBase.sdg.GOAL16Value'),
          icon: require("@/assets/image/SdgIcon/sdg_34.png")
        },
        {
          tit: this.$t('sdgDataBase.sdg.GOAL17'),
          content: this.$t('sdgDataBase.sdg.GOAL17Value'),
          icon: require("@/assets/image/SdgIcon/sdg_36.png")
        }
      ]
    }

  },
  methods: {
    toOther(index){
            this.current = index;
    },
    async getGoalList() {
      var res = await goalList();
      this.sdgList = res.data.data;
      this.$nextTick(() => {
        this._initScroll();
        this.personScroll();
        this.height();
              bus.$emit('showLoadingFun',false)
      });
      // console.log(this.sdgList, this.sdgImgage);
    },
    openMenu(idx, bg_color, index, id) {
      bus.$emit("openMenuFun", { idx, bg_color, index, id });
    },
    // 横轴初始化
    personScroll() {
      // 动态设置宽度
      let width = this.width();
      this.$refs.li1.style.width = width + "px";
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.personWrap, {
            click: true,
            // startX: 0,
            // click: true,
            scrollX: true,
            scrollY: false
            // eventPassthrough: "vertical",
            // bounce: false
          });
        } else {
          this.scroll.refresh();
        }
      });
    },

    //新建滚动实例  并监听竖轴滚动的高度
    _initScroll() {
      this.wrapperScroll = new BScroll(this.$refs.wrapper, {
        click: true, //better-scroll 默认会阻止浏览器的原生 click 事件。当设置为 true，better-scroll 会派发一个 click 事件，我们会给派发的 event 参数加一个私有属性 _constructed，值为 true。
        probeType: 3, //这个属性设置之后可以监听得到了
        bounce: true
      });

      //监听滚动事件
      this.wrapperScroll.on("scroll", pos => {
        // 当允许滚动并滚动的y轴小于0
        if (this.menuIndexChange && pos.y <= 0) {
          this.scrollY = Math.abs(Math.round(pos.y)); //滚动距离
          //   console.log(this.scrollY);
          // 循环每一个模块距离顶部的高度
          for (let i = 0; i < this.listHeight.length; i++) {
            let height1 = this.listHeight[i];
            let height2 = this.listHeight[i + 1];
            if (
              !height2 ||
              (this.scrollY >= height1 && this.scrollY < height2)
            ) {
              //   console.log(i);

              this._followScroll(i); //横轴动画移动
              this.currentIndex = i;
              return;
            }
          }
        }
      });
    },
    //获取横轴宽度
    width() {
      let wrap1 = this.$refs.li1.children;
      let sum = 0;
      for (var i = 0; i < wrap1.length; i++) {
        sum += wrap1[i].offsetWidth;
      }
      return sum + wrap1.length * 16 * 2;
    },
    //获取竖轴每个模块的高度
    height() {
      let wrap2 = this.$refs.li2.children;
      let height = 0;
      this.listHeight.push(height);
      for (let i = 0; i < wrap2.length; i++) {
        let item = wrap2[i];
        height += item.clientHeight;
        this.listHeight.push(height);
      }
      // console.log(this.listHeight);
    },

    //  点击横轴滚动
    select(index, event) {
      if (index == this.current) {
        this.current = 0;
      } else {
        this.current = index;
      }
      // console.log(index,event)

      // PC页面时,点击不会被 better-scroll阻止事件,初始化,给 better-scroll派发事件,使移动端拥有点击事件,因此切换到PC端时,点击事件会被执行两次,
      if (!event._constructed) {
        return;
      }

      this.currentIndex = this.current; //改变点击的当前样式
      this.menuIndexChange = false; //禁用竖轴滚动  防止横竖轴都改变index  解决运动时listenScroll依然监听的bug

      //横纵向右偏移16
      this._followScroll(this.current); //横轴动画移动

      //竖轴滚到响应位置
      let wrap2 = this.$refs.li2.children;
      let el = wrap2[this.current];
      this.wrapperScroll.scrollToElement(el, 300);

      //竖轴滚动结束后在允许动画
      this.wrapperScroll.on("scrollEnd", () => {
        this.menuIndexChange = true;
      });
    },

    // 横轴滚动到当前元素并向右移动16px
    _followScroll(index) {
      console.log(index);
      let wrap1 = this.$refs.li1.children;

      let el = wrap1[index];
      //   console.log(wrap1, el);
      if (index < 13) {
        // console.log(index, wrap1.length / 2);
        this.scroll.scrollToElement(el, 300, -450, 0);
      }
    }
  }
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.box {
  width: 100%;
  height: 100%;

}
.sdg_box_indicators{
  height: 100vh;
    background: red;
  .person-wrap {
  
  overflow: hidden;
  height: 120px;
  background: #3d3f4d;
  // border-bottom: 2px solid rgba(80,104,244,.6);
  .person-list {
    list-style-type: none;

    .person-item {
      float: left;
      width: 120px;
      // padding: 10px 10px;
      line-height: 36px;
      height: 120px;
      // margin: 0 16px;
      white-space: nowrap;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }
      .li_bg {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 99;
        background: rgba(0, 0, 0, 0.7);
      }
    }
    .li_bg_current {
      // background: rgba(80,104,244,.6);
      background: transparent !important;
      // z-index: 999;
      // color: #004299;
      //   border-bottom: 2px solid #004299;
    }
  }
}
.wrapper {
  height: calc(100vh - 120px);
  background: #f8f8f8;
  overflow: hidden;
  .content {
    display: block;
    .sdg_bg_box {
      height: calc(100vh - 120px);

      width: 100%;
      .cla_1 {
        height: calc(100vh - 120px);
        overflow-y: auto;
      }
      .sdg_bg_box_div {
        width: 100%;
        // height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        text-align: center;
        .back_{
          opacity: .5;
          position: absolute;
          top: 30px;
          // left: 50%;
          left: 0;
          background: rgba(255,255,255,.7);
          padding: 10px 10px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          // box-shadow: 0px 0px 5px #666;
          cursor: pointer;
          font-weight: 600;
           transition: .2s;
          // margin-left: -150px;
        }
        .back_:hover{
          transition: .2s;
            opacity: 1;
             background: rgba(255,255,255,.9);
        }
        //  background: rgba(194, 31, 50, 1);
        .first_page {
          // height: 100%;
          width: 100%;
          overflow-y: auto;
          background: rgba(243, 243, 243, 1);
          .first_page_box {
            img {
              width: 700px;
              height: 80px;
            }
            .first_page_box_text {
              width: calc(100vw - 200px);
              background: rgba(0, 184, 242, 1);
              color: #fff;
              border-radius: 30px;
              margin: 10px auto 20px;
              padding: 10px 40px;
              font-size: 18px;
              text-align: left;
            }
            .first_page_box_content {
              // height: 1200px;
              width: calc(100vw - 200px);
              margin: 10px auto;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              .first_page_box_content_target:hover .top_img {
                transform: translateY(-250px);
                transition: 0.2s ease-in;
                border-radius: 0;
              }
              .first_page_box_content_target:hover .text_ {
                height: 250px;
                transition: 0.2s ease-in;
                opacity: 0.8;
              }
              .first_page_box_content_target {
                cursor: pointer;
                width: 20%;
                padding: 0 4px;
                height: 250px;
                border-radius: 20px;
                margin-bottom: 10px;
                position: relative;
                overflow: hidden;
                .text_ {
                  transition: 0.2s ease-in;
                  position: absolute;
                  bottom: 0px;
                  left: 4px;
                  height: 50px;
                  padding: 0 10px;
                  right: 4px;
                  color: #fff;

                  .title {
                    display: flex;
                    // line-height: 50px;
                    font-weight: 600;
                    justify-content: flex-start;
                    align-items: center;
                    p{
                      text-align: left;
                      padding: 10px 0px;
                      font-size: 14px;
                      word-break: break-all;
                    }
                    img {
                      width: 36px;
                      height: 36px;
                      margin-right: 10px;
                      // z-index: 100;
                    }
                  }

                  .content {
                    font-size: 16px;
                    font-weight: 600;
                    margin-top: 20px;
                    text-align: left;
                  }
                }
                img {
                  transition: 0.2s ease-in;
                  width: 100%;
                  height: 100%;
                  border-radius: 10px;
                }
              }
            }
          }
        }
        .sdg_bg_box_title {
          color: #fff;
          padding-top: 26px;
          font-size: 24px;
          height: 90px;
          font-weight: 600;
          word-wrap:break-word;
          width: 80%;
          margin: 0 auto;
        }
        .sdg_bg_box_content {
          flex: 1;
          padding: 0px 50px;
          margin: 0 auto;
          display: flex;
          overflow: hidden;
          .sdg_bg_box_img {
            width: 50%;
            height: 100%;
            overflow: hidden;
            box-shadow: 0px 0px 20px #333;
            &:hover img {
              cursor: pointer;
              transition: 0.8s all;
              transform: scale(1.2); /*以y轴为中心旋转*/
            }
            img {
              transition: 0.8s all;
              width: 100%;
              height: 100%;
            }
          }
          .sdg_bg_box_text {
            background: url("../assets/image/Sdg/world.png") no-repeat;
            // background-size: 100% 100%;
            // background-position: cover;
            background-position: bottom;
            // background-size: 100% 100%;
            flex: 1;
            color: #fff;
            margin-left: 30px;
            .sdg_bg_box_text_content{
              max-height: 350px;
              overflow-y: auto;
             
              p{
                 font-size: 16px;
                 font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif
              }
             
            }
            > p {
              margin-top: 30px;
              text-align: left;
              font-size: 16px;
              text-indent: 40px;
            }
            .sdg_btn {
              margin-top: 20px;
              text-align: left;
              .sdg_btn_box {
                display: flex;
                align-items: center;
                padding: 4px 10px;
                cursor: pointer;
                transition: 0.8s;
                background: rgba(0, 0, 0, 0.1);
                border-bottom: 1px solid rgba(105, 83, 83, 0.322);
                &:hover {
                  transition: 0.8s;
                  background: rgba(0, 0, 0, 0.4);
                }
                .sdg_btn_box_p {
                  height: 30px;
                  line-height: 30px;
                  font-weight: 600;
                  font-size: 16px;
                  cursor: pointer;
                }
                &:hover .hr_ {
                  width: 120px !important;
                }
                .sdg_btn_box_i {
                  width: 120px;
                  height: 40px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  margin-left: 20px;

                  .hr_ {
                    width: 0px;
                    height: 4px;
                    // margin-left: -30px;
                    background: #fff;
                    transition: 0.3s;
                  }

                  .sdg_btn_box_i_posi {
                    position: relative;
                    i {
                      font-weight: 600;
                      font-size: 22px;
                      color: #fff;
                      position: absolute;
                      left: -14px;
                      top: -12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.sdg_bg_box_text_content::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
  scrollbar-arrow-color: red;
  cursor: pointer;
}
.sdg_bg_box_text_content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  /* border-radius: 5px; */
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: #ccc;
  scrollbar-arrow-color: red;
}
.sdg_bg_box_text_content::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
}

// /* https://blog.csdn.net/weixin_30872337/article/details/99666834?utm_medium=distribute.pc_relevant.none-task-blog-baidujs_title-1&spm=1001.2101.3001.4242 */
</style>